<template>
    <div v-if="!!currentOffer" class="w-full h-full bg-base flex flex-col">
        <div class="w-full max-h-420 grow-0 shrink-0" v-if="offerImage">
            <img :src="offerImage" class="h-full w-full object-cover">
        </div>
        <WFScrollableArea>
            <div class="flex flex-col gap-16">
                <div class="bg-detail p-36 gap-16 flex flex-col">
                    <div class="flex flex-col gap-12 justify-start">
                        <div class="font-bold text-18 px-10 py-2 bg-active rounded-sm self-start">
                            <WFTranslate k="floor" :params="[currentOffer.floor]"></WFTranslate>
                        </div>
                        <h2 class="card-title text-28 font-black" v-html="currentOffer.name"></h2>
                        <div class="flex w-full items-center gap-20">
                            <div class="p-12 bg-base">
                                <img :src="partnerLogo" class="h-64 max-w-278 object-contain"/>
                            </div>
                            <h3 class="font-black text-16">{{ partnerName }}</h3>
                        </div>
                    </div>
                    <div class="flex gap-16 w-full justify-between">
                        <OpenHours v-if="currentOffer.poi && currentOffer.poi.hasAttribute('opening_times')" :openingTimes="currentOffer.poi.getAttributeJSON('opening_times')"></OpenHours>
                        <PakkumiseQR :offer="currentOffer"></PakkumiseQR>
                    </div>
                    <div class="flex gap-28 w-full justify-stretch pt-0" v-if="currentOffer.poi">
                        <button class="th-btn th-btn-active basis-full" @click="onPOIClick"><WFIcon name="map" class="w-32 h-32"></WFIcon><WFTranslate k="show_path"></WFTranslate></button>
                        <button v-if="currentOffer.poi && currentOffer.poi.getAttributeString('360')" class="th-btn th-btn-stroke basis-full" @click="on360Click"><WFIcon name="360" class="w-32 h-32"></WFIcon><WFTranslate k="open-360"></WFTranslate></button>
                    </div>
                </div>
                <section class="text-16 p-36" v-html="currentOffer.description">

                </section>
            </div>
        </WFScrollableArea>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { WFScrollableArea } from '@3dwayfinder/wayfinder-vue-components'
import PakkumiseQR from "./PakkumiseQR.vue";
import OpenHours from "./OpenHours.vue";

export default {
    components: {
		WFScrollableArea,
        PakkumiseQR,
        OpenHours
    },
    computed: {
        ...mapState(['currentOffer']),
        offerImage () {
            if (this.currentOffer && this.currentOffer.images && this.currentOffer.images.length > 0) {
                let image = this.currentOffer.images[0];
                return image.full_path;
            }

            return '';
        },
        partnerLogo () {
            if (this.currentOffer && this.currentOffer.partner) {
                return this.currentOffer.partner.logo_full_path;
            }

            return "";
        },
        partnerName () {
            if (this.currentOffer && this.currentOffer.partner) {
                return this.currentOffer.partner.name;
            }

            return "";
        }
    },
    watch: {
        currentOffer() {
            console.log('currentOffer changed', this.currentOffer)
        }
    },
    methods: {
        offerFloor (offer) {
            return [offer.floor];
        },
        clicked (offer) {
            console.log('offer.clicked', offer)
            //this.$store.dispatch("setOffer", offer);
        },
        onPOIClick () {
            this.$store.dispatch("set360", false);
            this.$emit("onPOIClick", this.currentOffer.poi);
        },
        on360Click () {
            if (this.currentOffer.poi) {
                this.$store.dispatch("set360", this.currentOffer.poi.getAttributeString("360"));
            }
        }
    }
}
</script>